import React from "react";
import { useLocale } from "../../hooks";
import { useStaticQuery, graphql } from 'gatsby'
export const useAnimationContent = () => {
    const locale = useLocale();
    const {
        allContentfulPageAnimationSlide: { edges }
    } = useStaticQuery(
        graphql`
        query animationData {
            allContentfulPageAnimationSlide {
                edges {
                    node {
                        node_locale
                        timelineImage{
                            title
                            fluid {
                                ...GatsbyContentfulFluid_withWebp_noBase64
                            }
                        }
                        brookeBondText
                        thomasJLipton
                        vanDenBerghsInvests
                        mergeLeverBrothers {
                            heading
                        }
                        brookeBondTea
                        bushellsHoldings
                        pgTips
                        liptonIceTea {
                            heading
                        }
                        rainforestAlliance
                        liptonFruit
                        australiaTea
                        tazo {
                            heading
                        }
                        pgTipsBiodegradable
                        ekaterra
                        dragToExplore{
                            title
                            fluid {
                                ...GatsbyContentfulFluid_withWebp_noBase64
                            }
                        }
                        textPresent
                        skipNotification{
                            title
                            fluid {
                                ...GatsbyContentfulFluid_withWebp_noBase64
                            }
                        }
                    }
                }
            }
        }`
    )

    

    const localeData = locale
        ? edges.filter(({ node }) => node.node_locale === locale)
        : edges.filter(({ node }) => node.node_locale === 'en-GB')
    const site = localeData.reduce((acc, val) => ({ ...acc, ...val.node }), {})
    return site

}